import type { ServerEnvConfigType } from '@/shared/config/ServerEnvConfigType';
import type { DocsSiteVisitType } from '@/shared/constant/DocsIdTypeData';
import { OnlineType } from '@/shared/constant/OnlineType';
import type { LocaleType } from '@/shared/i18n/i18n';
import { clientRequest } from '@/shared/request/clientRequest.client';

export type RequestPasswordValidatorDataType = {
  id: string | number;
  password: string;
  projectId: number;
};

export async function requestPasswordValidator(
  requestData: RequestPasswordValidatorDataType,
  onlineType: OnlineType,
  envConfig: ServerEnvConfigType,
  clientI18n: (key: keyof LocaleType, params?: Record<string, string>) => string,
  visitType?: DocsSiteVisitType,
  subdirectory?: string,
) {
  const url = (() => {
    if (onlineType === OnlineType.SharedDoc) {
      return `/api/v1/shared-doc-auth`;
    }

    return `/api/v1/published-projects-auth`;
  })();

  return await clientRequest(
    url,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: new URLSearchParams({
        id: requestData.id.toString(),
        password: requestData.password.trim(),
      }),
      envConfig,
      projectId: Number(requestData.projectId || 0),
      visitType,
      subdirectory,
    },
    clientI18n,
  );
}
